
import { backOff } from "exponential-backoff";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import {SendInviteRequest, SendInviteResponse } from "../proto/api_pb";
import { RpcError } from "grpc-web";

export const sendInvite = async (
  accessToken:string,
  emailsList:string[],
  userId:string
  ):Promise<SendInviteResponse | RpcError | undefined> => {
  try {
    console.log('emailsList',emailsList, 'userId',userId)
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new SendInviteRequest();
    request.setInviterUserId(userId)
    request.setEmailsList(emailsList)
    const metadata = {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<SendInviteResponse | RpcError>((resolve, reject) => {
          ommuseClient.sendInvite(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};
